module.exports = __webpack_public_path__ + "static/media/eq.215b0a5c.jpg";